//react
import { useLocation } from 'react-router-dom';

// context hooks
import useAsp from 'hooks/useAps';
import { useEffect } from 'react';
//import { OrderType } from 'types/order';

const DapTag = () => {
  const { isThanks } = useAsp();
  const { pathname } = useLocation();
  useEffect(() => {
    const scriptId = 'dap';
    const isExsistScript = document.getElementById(scriptId);
    if (!!isExsistScript) isExsistScript.remove();
    const scriptId1 = 'dap-load1';
    const scriptId2 = 'dap-load2';
    const isExsistLoadScript1 = document.getElementById(scriptId1);
    if (!!isExsistLoadScript1) isExsistLoadScript1.remove();
    const isExsistLoadScript2 = document.getElementById(scriptId2);
    if (!!isExsistLoadScript2) isExsistLoadScript2.remove();

    if (isThanks) {
      const script1 = document.createElement('script');
      script1.src = 'https://tags.d-ap.net/o7AoJLwJ4Z3o7wJv9.js';
      script1.id = scriptId1;
      document.head.appendChild(script1);
      //const orderCode = order ? (order as OrderType).order_code : '';
      //const price = order ? order?.billing_amount + order?.tax_amount : 0;
      const script = document.createElement('script');
      script.id = scriptId;
      script.innerHTML = `
        var DAP_CV_NAME = "[ORDER_NUM]"; 
        var DAP_ORDER_DATA = "WiFi:[TOTAL_AMOUNT]:1"; 
        var DAPC = DAP_CV_NAME + "/" + DAP_ORDER_DATA;
        (function(){ DAP.conversion.send(DAPC, "0000000000039"); })();
      `;
      document.body.appendChild(script);
    } else {
      const script1 = document.createElement('script');
      script1.src = 'https://tags.d-ap.net/o7AoJLwJ4Z3o7wJv9.js';
      script1.id = scriptId1;
      script1.setAttribute('defer', '');
      document.head.appendChild(script1);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);
  return <></>;
};

export default DapTag;
